"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleableInputField = void 0;

var react_1 = __importStar(require("react"));

var InputField_1 = require("./InputField");

var InputField_styles_1 = require("./InputField.styles");

var ToggleableInputField = function ToggleableInputField(_a) {
  var labelOpen = _a.labelOpen,
      labelClosed = _a.labelClosed,
      onToggle = _a.onToggle,
      button = _a.button,
      hide = _a.hide,
      hideCouponLabel = _a.hideCouponLabel,
      props = __rest(_a, ["labelOpen", "labelClosed", "onToggle", "button", "hide", "hideCouponLabel"]);

  var _b = react_1.useState(!hide),
      open = _b[0],
      setOpen = _b[1];

  var clickLabelHandler = function clickLabelHandler() {
    setOpen(!open);
    onToggle && onToggle(props.id, !open);
  };

  return react_1.default.createElement(InputField_styles_1.ToggleableInputFieldContainer, {
    open: open
  }, react_1.default.createElement(InputField_1.InputField, __assign({}, props, {
    hide: hideCouponLabel !== undefined ? hideCouponLabel : hide,
    autoFocus: open,
    label: (open ? labelOpen : labelClosed) || props.label,
    onClickLabel: clickLabelHandler
  })), button && open && button());
};

exports.ToggleableInputField = ToggleableInputField;